import { action, observable, makeObservable } from 'mobx';
import { gameGlobalStates } from '../core/constants/reelConstants';

class GameStore {
  odd = 0;

  hasAutoBet = false;

  oddsInfo = [];

  replayData = null;

  isReplayWatchAgain = false;

  spinResult = {};

  noWinMatrix = [];

  gameInitialMatrix = [];

  isSpinStart = false;

  isExpandWildOpen = false;

  isNeedGetBalance = false;

  isNeedSpinAction = false;

  gameGlobalState = gameGlobalStates.none;

  isReelsRotating = false;

  skipWin = false;

  isResponseReady = false;

  isSpinButtonBlocked = false;

  isSpinButtonHold = false;

  isForceStop = false;

  canStop = false;

  hasWin = false;

  winEnded = true;

  wildsOpened = true;

  constructor() {
    makeObservable(this, {
      odd: observable,
      skipWin: observable,
      hasAutoBet: observable,
      gameGlobalState: observable,
      isSpinButtonHold: observable,
      isReplayWatchAgain: observable,
      isSpinButtonBlocked: observable,
      isForceStop: observable,
      wildsOpened: observable,
      isResponseReady: observable,
      isReelsRotating: observable,
      hasWin: observable,
      canStop: observable,
      winEnded: observable,
      replayData: observable,
      isSpinStart: observable,
      noWinMatrix: observable,
      isNeedSpinAction: observable,
      isExpandWildOpen: observable,
      isNeedGetBalance: observable,
      oddsInfo: observable.deep,
      spinResult: observable.deep,
      gameInitialMatrix: observable.deep,
      setIsForceStop: action.bound,
      setGameGlobalState: action.bound,
      setIsResponseReady: action.bound,
      setHasWin: action.bound,
      setSkipWin: action.bound,
      setCanStop: action.bound,
      setWinEnded: action.bound,
      setWildsOpened: action.bound,
      setIsReelsRotating: action.bound,
      setIsSpinButtonHold: action.bound,
      setOdd: action.bound,
      setOddsInfo: action.bound,
      setHasAutoBet: action.bound,
      setSpinResult: action.bound,
      setReplayData: action.bound,
      setIsSpinStart: action.bound,
      setNoWinMatrix: action.bound,
      setIsNeedGetBalance: action.bound,
      setIsExpandWildOpen: action.bound,
      setIsNeedSpinAction: action.bound,
      setGameInitialMatrix: action.bound,
      setIsReplayWatchAgain: action.bound,
    });
  }

  setWildsOpened(bool) {
    this.wildsOpened = bool;
  }

  setGameGlobalState(state) {
    console.log(state);
    this.gameGlobalState = state;
  }

  setWinEnded(bool) {
    this.winEnded = bool;
  }

  setHasWin(bool) {
    this.hasWin = bool;
  }

  setIsReelsRotating(bool) {
    this.isReelsRotating = bool;
  }

  setIsReplayWatchAgain(bool) {
    this.isReplayWatchAgain = bool;
  }

  setCanStop(bool) {
    this.canStop = bool;
  }

  setSkipWin(bool) {
    this.skipWin = bool;
  }

  setIsResponseReady(bool) {
    this.isResponseReady = bool;
  }

  setIsForceStop(bool) {
    this.isForceStop = bool;
  }

  setIsSpinButtonHold(bool) {
    this.isSpinButtonHold = bool;
  }

  setReplayData(data) {
    this.replayData = data;
  }

  setHasAutoBet(bool) {
    this.hasAutoBet = bool;
  }

  setIsExpandWildOpen(bool) {
    this.isExpandWildOpen = bool;
  }

  setIsNeedSpinAction(bool) {
    this.isNeedSpinAction = bool;
  }

  setIsNeedGetBalance(bool) {
    this.isNeedGetBalance = bool;
  }

  setNoWinMatrix(matrix) {
    this.noWinMatrix = matrix;
  }

  setOdd(value) {
    this.odd = value;
  }

  setSpinResult(spinResult) {
    this.spinResult = spinResult;
  }

  setGameInitialMatrix(matrix) {
    this.gameInitialMatrix = matrix;
  }

  setOddsInfo(oddsInfo) {
    this.oddsInfo = oddsInfo.reduce((acc, cur) => {
      acc.push(cur.reverse().filter((item) => !!item));
      return acc;
    }, []);
  }

  setIsSpinStart(bool) {
    this.isSpinStart = bool;
  }
}

export const gameStore = new GameStore();
